<template>
  <div class="cs-container" style="min-width: 1400px">
    <input
      ref="inputFileData"
      type="file"
      multiple
      charset="utf-8"
      accept=".stp, .step, .stl"
      v-show="false"
      @change="changeInputFile"
    />
    <div v-if="estimate.id" class="flex items-end px-2 mb-3">
      <h1 class="text-5xl font-bold">견적서</h1>
      <span class="ml-2 text-xl font-normal text-desc">no.{{ estimate.id }}</span>
    </div>
    <div v-if="estimate.id" class="flex w-full h-full">
      <div class="relative w-full">
        <div class="flex justify-end items-center mb-2 w-full">
          <button
            class="flex items-center px-3 py-2 text-center cs-btn cs-btn-default"
            @click="onPrint"
          >
            <img src="../assets/images/printer.png" class="m-auto mr-1 w-5" />
            <span class="block mt-1 text-xs font-medium">Print</span>
          </button>
          <div class="w-[5px]"></div>
          <button
            class="flex items-center px-3 py-2 text-center cs-btn cs-btn-default"
            @click="onGoPacking"
          >
            <img src="../assets/images/delivery-box.png" class="m-auto mr-1 w-5" />
            <span class="block mt-1 text-xs font-medium">3D Packing</span>
          </button>
        </div>

        <processes
          v-if="isShowProcesses"
          @onShow="onShowProcesses"
          :currentModel="selectedModel"
        ></processes>
        <div v-if="!isShowProcesses">
          <admin-model
            v-for="model in models"
            :key="model.id"
            :model="model"
            @onShowCompanys="onShowCompanys"
          ></admin-model>
        </div>

        <div
          v-if="false"
          ref="dragDropContainer"
          class="relative py-8 w-full text-center bg-white rounded-md border border-line upload-area"
          v-cloak
          @dragenter.prevent="onDragEnter"
          @dragend.prevent="onDragEnd"
        >
          <div class="">
            <button
              class="m-auto w-80 cs-btn cs-pd-btn-sm"
              :class="isEstimateSubmit ? 'cs-btn-disabled' : 'cs-btn-second'"
              :disabled="isEstimateSubmit"
              @click="inputFileFocus"
            >
              <div class="flex justify-center items-center text-lg font-semibold">
                <i class="text-xl fi fi-rr-cloud-upload-alt"></i>
                <span class="ml-1">STL, STP, STEP 파일 업로드</span>
              </div>
            </button>
            <div class="m-auto mt-2 w-80 cs-caption">
              <i class="mr-1 fi fi-br-exclamation"></i>
              <div class="text-left">
                <p style="line-height: 1.3">
                  최대 10개 모델 업로드 가능합니다.<br />해당 영역에 드래그&드롭으로 업로드
                  가능합니다.
                </p>
              </div>
            </div>
          </div>
          <div class="flex justify-center mt-6">
            <div class="flex items-center">
              <span class="mr-3 text-default">단위선택</span>
              <div class="flex">
                <button
                  class="px-4 py-2 rounded-l-full border-t border-b border-l border-input"
                  :class="['mm' === unit ? 'bg-white' : 'unit-unactive']"
                  @click="onUnit('mm')"
                >
                  <span class="" :class="['mm' === unit ? 'font-semibold' : 'text-placeholder']"
                    >mm</span
                  >
                </button>
                <span class="border-l border-input"></span>
                <button
                  class="px-4 py-2 rounded-r-full border-t border-r border-b border-input"
                  :class="['inch' === unit ? 'bg-white' : 'unit-unactive']"
                  @click="onUnit('inch')"
                >
                  <span class="" :class="['inch' === unit ? 'font-semibold' : 'text-placeholder']"
                    >inch</span
                  >
                </button>
              </div>
            </div>
          </div>

          <div
            v-if="isDraging"
            class="drop-area"
            ref="dropContent"
            id="dropContent"
            v-cloak
            @drop.prevent="onDrop"
            @dragenter.prevent
            @dragover.prevent
            @dragleave.stop="onDragLeave"
          >
            <div class="drop-area-inner" :class="{active: isDraging}">
              <i
                class="text-4xl text-white fi fi-sr-cloud-upload-alt drop-area-icon md:text-7xl"
              ></i>
              <div class="text-white drop-area-desc">
                <p class="font-semibold md:text-lg">파일을 업로드하려면 여기에 드롭하세요.</p>
              </div>
            </div>
          </div>

          <div
            v-if="AnalysisStatus.Pass !== isEnabled"
            class="justify-center items-center rounded-md bounding-loader"
          >
            <div class="loader-boxs">
              <div class="scene">
                <div class="plane">
                  <div class="cube cube--0">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--0"></div>
                  <div class="cube cube--1">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--1"></div>
                  <div class="cube cube--2">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--2"></div>
                  <div class="cube cube--3">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--3"></div>
                  <div class="cube cube--4">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--4"></div>
                  <div class="cube cube--5">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--5"></div>
                  <div class="cube cube--6">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--6"></div>
                  <div class="cube cube--7">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--7"></div>
                </div>
              </div>
            </div>
            <div class="text-center bounding-loader-text">
              <p v-if="AnalysisStatus.Processing === isEnabled" class="text-lg">
                초기화 중 입니다, 잠시만 기다려주세요.
              </p>
              <p v-if="AnalysisStatus.Fail === isEnabled" class="text-lg">
                관리자 설정이 필요합니다, 관리자에게 문의해주세요.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="px-2" style="min-width: 330px; max-width: 330px">
        <div class="overflow-hidden w-full rounded-md border estimate-content border-line">
          <div class="flex relative justify-center items-center py-3 bg-black">
            <img class="sub-logo" src="../assets/images/logo.png" />
            <button class="header-right-btn cs-icon-btn black" @click="onGoToList">
              <i class="flex text-white fi fi-br-exit"></i>
            </button>
          </div>
          <div class="px-7 py-4 bg-deepgray text-gray">
            <div class="flex">
              <div class="w-full text-center">
                <span><i class="fi fi-rr-cubes1"></i>모델</span>
                <span class="ml-2">{{ models.length }}개</span>
              </div>
              <div class="border-l border-line"></div>
              <div class="w-full text-center">
                <span><i class="fi fi-rr-box-open-full1"></i>수량</span>
                <span class="ml-2">{{ totalQua }}개</span>
              </div>
            </div>

            <div class="mt-4 mb-4 border-b border-line"></div>

            <div class="flex items-center h-5">
              <i class="text-lg fi fi-rr-user"></i
              ><span class="ml-3">{{ estimate.clientName }}</span>
            </div>
            <div class="flex items-center mt-2 h-5">
              <i class="text-lg fi fi-rr-building"></i
              ><span class="ml-3">{{ estimate.clientCompany }}</span>
            </div>
            <div class="flex items-center mt-2 h-5">
              <i class="text-lg fi fi-rr-envelope-open"></i
              ><span class="ml-3">{{ estimate.clientEmail }}</span>
            </div>
            <div class="flex items-center mt-2 h-5">
              <i class="text-lg fi fi-rr-mobile-notch"></i
              ><span class="ml-3">{{ estimate.clientPhone }}</span>
            </div>
            <div v-if="estimate.createdAt" class="mt-5 text-sm text-right">
              {{ dateConvertYMDHM(new Date(estimate.createdAt).getTime() / 1000) }}
            </div>
          </div>
          <div class="px-7 py-6 bg-white border-b border-line">
            <div class="flex justify-between items-center font-normal">
              <span class="text-placeholder">출력 비용</span>
              <div class="flex w-40 cs-form" data-height="s">
                <input
                  class=""
                  v-model="estimateBuildCost"
                  @keyup="onBuildCost"
                  type="text"
                  placeholder="0"
                />
                <span>원</span>
              </div>
            </div>
            <div class="flex justify-between items-center mt-3 font-normal">
              <span class="text-placeholder">후처리 비용</span>
              <div class="flex w-40 cs-form" data-height="s">
                <input
                  class=""
                  v-model="estimatePPCost"
                  @keyup="onPostProcessCost"
                  type="text"
                  placeholder="0"
                />
                <span>원</span>
              </div>
            </div>
            <div class="flex justify-between items-center mt-3 font-normal">
              <span class="text-placeholder">도색 비용</span>
              <div class="flex w-40 cs-form" data-height="s">
                <input
                  class=""
                  v-model="estimatePaintCost"
                  @keyup="onPaintCost"
                  type="text"
                  placeholder="0"
                />
                <span>원</span>
              </div>
            </div>
            <div class="flex justify-between items-center mt-3 font-normal">
              <span class="text-placeholder">배송 비용</span>
              <div class="flex w-40 cs-form" data-height="s">
                <input
                  class=""
                  v-model="estimateSippingCost"
                  @keyup="onShippingCost"
                  type="text"
                  placeholder="0"
                />
                <span>원</span>
              </div>
            </div>
            <div class="flex justify-between mt-6 font-normal">
              <p class="text-placeholder">동시제작 할인비용</p>
              <p
                class="text-lg font-semibold text-right"
                :class="0 > estimate.discountCost * -1 ? 'text-danger' : ''"
              >
                {{ discountCost }} 원
              </p>
            </div>
          </div>
          <div class="px-7 py-6 bg-white">
            <div class="flex justify-between font-normal">
              <span class="mt-1">총 비용</span>
              <span class="text-4xl font-bold text-right text-second">{{ totalCost }} 원</span>
            </div>
          </div>
          <div class="flex justify-center items-center px-7 pt-5 pb-5 bg-white">
            <loader-button
              ref="next"
              class="w-full cs-pd-btn"
              :cssButton="'cs-btn-danger'"
              @click="onDelete"
            >
              <template v-slot:title><span>견적서 삭제</span></template>
            </loader-button>

            <div class="w-[10px] h-1 bg-line"></div>

            <loader-button
              ref="submit"
              class="w-full cs-pd-btn"
              :cssButton="'cs-btn-base'"
              @click="onSubmit"
            >
              <template v-slot:title>
                <span>견적서 {{ estimate.isActive ? "수정" : "제출" }}</span>
              </template>
            </loader-button>
          </div>
        </div>
      </div>
    </div>

    <modal-analysis v-if="isVisibleViewer" :model="currentModel"></modal-analysis>
  </div>
</template>

<script setup>
import {ref, computed, onMounted, watch} from "vue";
import {storeToRefs} from "pinia";
import {useRouter, useRoute} from "vue-router";
import {OptionsStore} from "../store/options-store";
import {EstimateStore} from "../store/estimate-store";
import {ModelStore} from "../store/model-store";
import {CommonStore} from "../store/common-store";
import {CompanyStore} from "../store/company-store";
import {changeInputFile, preProcessingFileUpload} from "../js/upload";
import {AnalysisStatus, Modals} from "../js/types";
import {numberToComma, dateConvertYMDHM, removeComma} from "../js/utils";
import AdminModel from "./components/admin-model.vue";
import Processes from "./components/process-list.vue";
import ModalAnalysis from "./modals/modal-analysis.vue";
import LoaderButton from "../components/LoaderButton.vue";

const commonStore = CommonStore();
const {isViewLoader, modalResult} = storeToRefs(commonStore);
const optionsStore = OptionsStore();
const {isEnabled} = storeToRefs(optionsStore);
const estimateStore = EstimateStore();
const {estimate, isEstimateSubmit} = storeToRefs(estimateStore);
const {models, currentModel, totalQua} = storeToRefs(ModelStore());
const inputFileData = ref();
const router = useRouter();
const route = useRoute();
let unit = ref("mm");
let isDraging = ref(false);
let isShowProcesses = ref(false);
const isVisibleViewer = ref(false);
const selectedModel = ref();
let estimateBuildCost = ref("0");
let estimatePPCost = ref("0");
let estimatePaintCost = ref("0");
let estimateSippingCost = ref("0");
const discountCost = computed(() => {
  return numberToComma(models.value.length ? estimate.value.discountCost * -1 : 0);
});
const totalCost = computed(() => {
  return models.value.length ? numberToComma(estimate.value.totalCost) : 0;
});
watch(
  () => estimate.value,
  () => {
    estimateBuildCost.value = "" + numberToComma(estimate.value.buildCost);
    estimatePPCost.value = "" + numberToComma(estimate.value.postProcessCost);
    estimatePaintCost.value = "" + numberToComma(estimate.value.paintCost);
    estimateSippingCost.value = "" + numberToComma(estimate.value.shippingCost);
  },
  {deep: true, immediate: true}
);
watch(currentModel, (newV) => {
  if (newV.id) {
    isVisibleViewer.value = true;
  } else {
    isVisibleViewer.value = false;
  }
});
watch(modalResult, async (newV) => {
  switch (newV.modalName) {
    case Modals.EstimateTrash:
      CommonStore().closeGlobalModal();
      isViewLoader.value = true;
      await estimateStore.reqDelete();
      isViewLoader.value = false;
      router.push({name: "admin-estimates"});
      break;
    case Modals.SubmiEstimate:
      router.back();
      break;
  }
});
onMounted(async () => {
  CompanyStore().reqProcesses();
  isViewLoader.value = true;
  await optionsStore.reqGetOptions();
  estimateStore.reqGetEstimate(route.params.estimateId);
});
const onUnit = (srcUnit) => {
  unit.value = srcUnit;
};
const inputFileFocus = () => {
  if (inputFileData.value) {
    inputFileData.value.click();
  }
};
const numberComma = (src) => {
  if (src.length) {
    src = src.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
    if (src.length) {
      return numberToComma(Number.parseInt(removeComma(src)));
    }
  }
  return "";
};
const onShowCompanys = (sModel) => {
  selectedModel.value = sModel;
  onShowProcesses(true);
};
const onShowProcesses = (isShow) => {
  isShowProcesses.value = isShow;
};
const onDrop = (e) => {
  isDraging.value = false;
  e.preventDefault();
  if (e.dataTransfer) {
    let droppedFiles = e.dataTransfer.files;
    if (!droppedFiles) return;
    preProcessingFileUpload(droppedFiles);
  }
};
const onDragEnter = () => {
  isDraging.value = true;
};
const onDragLeave = () => {
  isDraging.value = false;
};
const onDragEnd = () => {
  isDraging.value = false;
};
const onGoToList = () => {
  estimateStore.reqSave();
  router.push({name: "admin-estimates"});
};
const onDelete = () => {
  const data = {
    modalName: Modals.EstimateTrash,
    isShowCancel: false,
    title: "확인",
    content: "해당 견적서를 삭제하시겠습니까?",
    result: {estimateId: route.params.estimateId},
  };
  CommonStore().showGlobalModal(data);
};
const onSubmit = () => {
  estimateStore.reqFinalSubmit();
};
const onPrint = async () => {
  estimate.value.buildCost = Number.parseInt(removeComma(estimateBuildCost.value));
  estimate.value.shippingCost = Number.parseInt(removeComma(estimateSippingCost.value));
  estimate.value.postProcessCost = Number.parseInt(removeComma(estimatePPCost.value));
  estimate.value.paintCost = Number.parseInt(removeComma(estimatePaintCost.value));
  await estimateStore.reqSave();
  window.open(`/estimate/print?estimateId=${estimate.value.id}`, "_blank");
};
const onGoPacking = () => {
  window.open(`/packing-viewer?estimateId=${estimate.value.id}`, "_blank");
};
const onBuildCost = () => {
  estimateBuildCost.value = numberComma(estimateBuildCost.value);
  estimate.value.buildCost = Number.parseInt(removeComma(estimateBuildCost.value));
  EstimateStore().calculateTotalCost({buildCost: estimate.value.buildCost});
};
const onPostProcessCost = () => {
  estimatePPCost.value = numberComma(estimatePPCost.value);
  estimate.value.postProcessCost = Number.parseInt(removeComma(estimatePPCost.value));
  EstimateStore().calculateTotalCost({postProcessCost: estimate.value.postProcessCost});
};
const onPaintCost = () => {
  estimatePaintCost.value = numberComma(estimatePaintCost.value);
  estimate.value.paintCost = Number.parseInt(removeComma(estimatePaintCost.value));
  EstimateStore().calculateTotalCost({paintCost: estimate.value.paintCost});
};
const onShippingCost = () => {
  estimateSippingCost.value = numberComma(estimateSippingCost.value);
  estimate.value.shippingCost = Number.parseInt(removeComma(estimateSippingCost.value));
  EstimateStore().calculateTotalCost({shippingCost: estimate.value.shippingCost});
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.sub-logo {
  height: 30px;
}

.header-right-btn {
  position: absolute;
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
}

.upload-area {
  transition: 0.2s all;

  &:hover {
    border: 1px solid #c5e1ff;
    background-color: #f7fbff;
  }
}

.unit-unactive {
  background-color: rgb(243 244 246);
}

.estimate-content {
  position: sticky;
  top: 1rem;
  width: 330px;
}
</style>
